/**
 * Returns a new array with n elements removed from the left.
 */
const drop = (arr, n = 1) => arr.slice(n);

export default drop;
